import {useSelector} from "react-redux";
import {useGetUser} from "hooks";
import View from "./View";

export default function Container({redbrickEventProjectKey}) {
  const {userinfo, game} = useSelector(state => state);
  const {data: user} = useGetUser(userinfo.id);
  const {gameState} = game;

  return <View user={user} gameState={gameState} redbrickEventProjectKey={redbrickEventProjectKey} />;
}
